// Browser-safe account matching. An explicit managed OAuth option must not select a native adapter.
export function connectionProviderMatches(option, actual) {
    const base = (id) => id.endsWith('_composio') ? id.slice(0, -'_composio'.length) : id;
    return option.endsWith('_composio') ? option === actual : base(option) === base(actual);
}
//# sourceMappingURL=connection-provider.js.map